// #region imports

// --- Angular
import { Component, ElementRef } from '@angular/core';

// --- HS Code
import { NavBarBaseComponent } from '../../core/nav-bar/nav-bar-base.component';

// #endregion

@Component({
  selector: 'hs-logo-nav',
  templateUrl: './logo-nav.component.html',
  styleUrls: ['./logo-nav.component.scss']
})
export class LogoNavComponent extends NavBarBaseComponent {

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }

}
